/**
 * A key of its own, not a field of `preferences`: every `useLocalStorage('preferences')` writes back the
 * snapshot it read on mount, which would wipe a list written from outside it.
 */
export const HIDDEN_FLEETS_KEY = 'checklist-compliance-nudge-hidden-fleets';

const readHiddenFleetIds = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const stored = JSON.parse(window.localStorage.getItem(HIDDEN_FLEETS_KEY) ?? '[]');
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

/**
 * Read straight from localStorage on every call, not through `useLocalStorage`: the checklist drawer
 * hides the nudge from another component, and a per-hook copy would keep showing it.
 */
export const isChecklistComplianceNudgeHidden = (fleetId: string): boolean => readHiddenFleetIds().includes(fleetId);

export const hideChecklistComplianceNudge = (fleetId: string) => {
  if (typeof window === 'undefined' || !fleetId || isChecklistComplianceNudgeHidden(fleetId)) return;
  try {
    window.localStorage.setItem(HIDDEN_FLEETS_KEY, JSON.stringify([...readHiddenFleetIds(), fleetId]));
  } catch {
    // localStorage unavailable: the nudge comes back next session, which is harmless.
  }
};
